module.exports = __webpack_public_path__ + "static/media/total-harmony-1.90fe364a.jpg";